const CHUNK_RECOVERY_KEY = "justkasz:chunk-recovery-attempt";

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

const chunkFailurePatterns = [
  /chunkloaderror/i,
  /loading chunk [^ ]+ failed/i,
  /failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /importing a module script failed/i,
  /unable to preload css/i,
];

function errorMessage(reason: unknown): string {
  if (reason instanceof Error) return `${reason.name}: ${reason.message}`;
  return String(reason ?? "");
}

export function isStaleBundleFailure(reason: unknown): boolean {
  const message = errorMessage(reason);
  return chunkFailurePatterns.some((pattern) => pattern.test(message));
}

export function claimChunkRecovery(storage: StorageLike, path: string, now = Date.now()): boolean {
  const existing = storage.getItem(CHUNK_RECOVERY_KEY);
  if (existing) return false;

  storage.setItem(
    CHUNK_RECOVERY_KEY,
    JSON.stringify({ path, attemptedAt: new Date(now).toISOString() }),
  );
  return true;
}

export function clearChunkRecovery(storage: StorageLike): void {
  storage.removeItem(CHUNK_RECOVERY_KEY);
}

export function recoverStaleBundle(
  reason: unknown,
  dependencies: {
    storage: StorageLike;
    path: string;
    reload: () => void;
  },
): boolean {
  if (!isStaleBundleFailure(reason)) return false;
  if (!claimChunkRecovery(dependencies.storage, dependencies.path)) return false;
  dependencies.reload();
  return true;
}
